module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/items/armchairs/armchairs.png";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/items/armchairs/armchairs.png
// module id = 510
// module chunks = 0